import React from "react";
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom";
import cx from "classnames";
import { Layout, Avatar, Dropdown } from "antd";
import {
  UserOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PoweroffOutlined,
  LockOutlined,
} from "@ant-design/icons";

import { useAuth } from "../backend/useAuth";
import { selectTheme, toggleSiderFullCollapsedAction } from "features/theme/themeSlice"

const { Header } = Layout;

const HeaderOne = () => {
  const { logout } = useAuth();
  const dispatch = useDispatch();
  const { sider, header } = useSelector(selectTheme);

  const items = [
    {
      key: "item-1",
      icon: <LockOutlined />,
      label: <Link to="/auth/change-pass">Change Password</Link>,
    }, // remember to pass the key prop
    {
      key: "item-2",
      danger: true,
      icon: <PoweroffOutlined />,
      onClick: () => logout('/auth/login'),
      label: "Logout",
    },
  ];

  return (
    <Header className={cx({ "ant-header-fixed": header.fixed })}>
      {React.createElement(sider.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
        className: "trigger",
        onClick: () => dispatch(toggleSiderFullCollapsedAction()),
      })}
      {/* <Header className="bg-white" style={{ padding: 0 }} /> */}
      <Dropdown menu={{ items }} placement="topRight" arrow>
        <div className="user-box">
          <Avatar
            className="bg-primary"
            style={{
              verticalAlign: "middle",
            }}
            size="large"
            // gap={gap}
            icon={<UserOutlined />}
          >
            {/* {user.displayName} */}
          </Avatar>
          {/* <DownOutlined /> */}
          {/* <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
            Click me
          </a> */}
        </div>
      </Dropdown>
    </Header>
  );
};

export default HeaderOne;
